module.exports = __webpack_public_path__ + "web_static/img/smartliving_ac_1015.88bfeebd.png";